import { render, staticRenderFns } from "./Card3.vue?vue&type=template&id=bc630ddc&scoped=true&"
import script from "./Card3.vue?vue&type=script&lang=js&"
export * from "./Card3.vue?vue&type=script&lang=js&"
import style0 from "./Card3.vue?vue&type=style&index=0&id=bc630ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc630ddc",
  null
  
)

export default component.exports